import { ArsTableCellType, ArsTableRowHeaderCell } from "../interface";
import { isArsTableCellBase } from "./isArsTableCellBase";

/**
 * Type guard for ArsTableRowHeaderCell, which is a possible type of ArsTableCellBase.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the cell's displayContent and annotationContent
 * @returns - True if the object is an ArsTableRowHeaderCell, false otherwise
 */
export const isArsTableRowHeaderCell = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableRowHeaderCell<T> => {
  if (!isArsTableCellBase<T>(obj, isT)) return false;
  const rowHeaderCell = obj as ArsTableRowHeaderCell<T>;

  if (rowHeaderCell.cellType !== ArsTableCellType.RowHeader) return false;
  if (!["number", "undefined"].includes(typeof rowHeaderCell.width)) return false;

  // Everything is good
  return true;
};
